module.exports = __webpack_public_path__ + "img/merchant.8427c0b5.svg";